module.exports = __webpack_public_path__ + "static/media/anti-drill.bef3895b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/anti-drill.png
// module id = 1215
// module chunks = 0